import React from 'react';

const MAIL_NEWS_LIST = [
    {
        key: 'isSubscribedMonthlyNews',
        label: 'elephamt for pharmacists MONTHLY NEWS',
        description: '毎月新たに掲載した講座とそれに含まれるコンテンツ情報を配信',
        schedule: '配信日: 毎月第一営業日'
    },
    {
        key: 'isSubscribedNewDrugMail',
        // #17916 — text update per customer request (was 新薬メール / 追加収載された新薬情報を配信).
        label: '薬剤情報メール',
        description: '追加収載された新薬情報等を配信',
        schedule: '配信日: 随時配信'
    },
    {
        key: 'isSubscribedGuidelineMail',
        label: '診療ガイドラインメール',
        description: '主な診療ガイドライン情報の更新情報を配信',
        schedule: '配信日: 随時配信'
    }
];

/**
 * Form メールニュース受信設定 — shared by /account-setting (with ProfileLayout) and /mail-subscription (no menu).
 */
export default function MailNewsSubscriptionForm({
    settings,
    onToggle,
    onSave,
    tabModifierClass = 'mail-settings-tab--account',
    isSaving = false
}) {
    return (
        <div className={`mail-settings-tab ${tabModifierClass}`}>
            <div className="mail-settings-tab__form">
                <div className="mail-settings-tab__card">
                    <p className="mail-settings-tab__instruction">
                        希望するメールにチェックをしてください（希望しない場合は、チェックを外してください。）<br />
                        「設定」ボタンをクリックすると設定内容が保存されます。
                    </p>

                    <div className="mail-settings-tab__box">
                        <div className="mail-settings-tab__box-title">メールニュースの配信先</div>
                        <div className="mail-settings-tab__list">
                            {MAIL_NEWS_LIST.map((item) => (
                                <div key={item.key} className="mail-settings-tab__row">
                                    <div className="mail-settings-tab__label-col">
                                        <input
                                            type="checkbox"
                                            id={`mail-setting-${item.key}`}
                                            checked={settings[item.key]}
                                            disabled={isSaving}
                                            onChange={() => onToggle(item.key)}
                                            className="mail-settings-tab__checkbox"
                                        />
                                        <label
                                            htmlFor={`mail-setting-${item.key}`}
                                            className="mail-settings-tab__label-text"
                                        >
                                            {item.label}
                                        </label>
                                    </div>
                                    <div className="mail-settings-tab__desc-col">
                                        <div className="mail-settings-tab__desc">{item.description}</div>
                                        <div className="mail-settings-tab__schedule">{item.schedule}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mail-settings-tab__submit-wrap">
                    <button
                        type="button"
                        className="mail-settings-tab__submit"
                        onClick={onSave}
                        disabled={isSaving}
                    >
                        {isSaving ? '保存中…' : '設定'}
                    </button>
                </div>
            </div>
        </div>
    );
}
